import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { AppContext } from '../context/context';

function TooltipDisposer() {
  const location = useLocation();
  const {
    tooltips,
    setTooltips,
    hideAllTooltip,
    disposeAllTooltip,
  } = useContext(AppContext)

  useEffect(() => {

    disposeAllTooltip()

  }, [location.pathname]);

  useEffect(() => {
    // console.log("TOOLTIP LENGTH", tooltips.length)

  }, [tooltips])



  return null;
}

export default TooltipDisposer;